import variables from 'swag-client-common/styles/variables-js.scss';
const STYLES = {
  moreImagesButton: {
    color: '#777777',
    fontFamily: variables.fontFamilyBold,
    letterSpacing: '0px',
    opacity: 1
  }
};
export default STYLES;